import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "36.2",
  width: "50",
  viewBox: "0 0 50 36.2",
  fill: "#1aa",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M45.45 0H4.55C2.05 0 0 2.05 0 4.55V9h50V4.55C50 2.05 47.95 0 45.45 0zM0 31.65c0 2.5 2.05 4.55 4.55 4.55h40.9c2.5 0 4.55-2.05 4.55-4.55V16H0v15.65z"
  })]
});